import React, { useState } from 'react'
import './LandingPage.css'
import { useHistory } from 'react-router-dom'
import { SmallSpinner } from '../../utilities/spinner/Spinner'

//Redux
import { signUp } from '../../redux'
import { useDispatch, useSelector } from 'react-redux'
//Bootstrap
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'

function Signup() {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [retypePassword, setRetypePassword] = useState('')
  const [isPasswordMatched, setIsPasswordMatched] = useState(false)

  const ui = useSelector((state) => state.ui)

  const dispatch = useDispatch()

  const history = useHistory()

  const handlePassword = (e) => {
    setPassword(e.target.value)
    if (retypePassword.length > 0 || e.target.value > 0) {
      setIsPasswordMatched(retypePassword === e.target.value)
    }
  }
  const handleRetypePassword = (e) => {
    setRetypePassword(e.target.value)
    if (password.length > 0 || e.target.value > 0) {
      setIsPasswordMatched(password === e.target.value)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    dispatch(signUp({ name, email, password }))
    
  }

  return (
    <div>
      <div className='signup-wave no-select'>
        <img src='/svg/purpleWave.svg' alt='wave' style={{ width: '100%', height: '100%' }} />
      </div>
      <div className='signup-img no-select'>
        <img src='/svg/signup.svg' alt='login' style={{ height: '100%' }} />
      </div>
      <div className='signup-form-container'>
        <Form className='signup-form-style '>
          <Form.Group controlId='name'>
            <Form.Label>Name</Form.Label>
            <Form.Control type='text' placeholder='Enter Your Name' onChange={(e) => setName(e.target.value)} value={name} disabled={ui.loading}/>
          </Form.Group>

          <Form.Group controlId='email'>
            <Form.Label>Email address</Form.Label>
            <Form.Control type='email' placeholder='Enter email' onChange={(e) => setEmail(e.target.value)} value={email} disabled={ui.loading}/>
          </Form.Group>

          <Form.Group controlId='password'>
            <Form.Label>Password</Form.Label>
            <Form.Control type='password' placeholder='Password' onChange={(e) => handlePassword(e)} value={password} disabled={ui.loading}/>
          </Form.Group>

          <Form.Group controlId='retypePassword'>
            <Form.Label>Retype Password</Form.Label>
            <Form.Control
              type='password'
              placeholder='Retype Password'
              onChange={(e) => handleRetypePassword(e)}
              value={retypePassword}
              disabled={ui.loading}
            />
            {isPasswordMatched ? <Form.Text className='text-muted'>Password matched!</Form.Text> : null}
          </Form.Group>

          <Button variant='dark' type='submit' onClick={(e) => handleSubmit(e)} style={{ width: '100px' }} disabled={ui.loading}>
            <div>Sign Up{ui.loading && <SmallSpinner />}</div>
          </Button>
        </Form>
      </div>
    </div>
  )
}

export default Signup
